
const toggleLoading = (loader, show = true) => {
    //loader.style.display = show ? "flex" : "none";
};

const showSuccessMessage = () => {
    const cfSuccess = document.getElementById('contactFormSuccess');
    cfSuccess.classList.add('opacity-100');
    cfSuccess.classList.remove('d-none');

    setTimeout(() => cfSuccess.classList.remove('opacity-100'), 5000);
};

const validateField = (field) => {
    const isValid = field.type !== 'checkbox' ? Boolean(field.value) : field.checked;
    field.classList.toggle('is-invalid', !isValid);
    field.classList.toggle('is-valid', isValid);

    return isValid;
};

const closeSuccessMessage = () => {
    const cfSuccess = document.getElementById('contactFormSuccess');

    cfSuccess.classList.add('d-none');
};


const checkRequiredFields = (fields) => fields.every(validateField);

const submitForm = async (form, submitButton, loader) => {
    const requiredFields = form.querySelectorAll('[required]');

    if (!checkRequiredFields(Array.from(requiredFields))) {
        return;
    }

    toggleLoading(loader);

    try {
        const formData = new FormData(form);
        formData.append('action', 'contact_form');

        const response = await fetch(form.dataset.ajaxurl, { method: 'POST', body: formData });
        const data = await response.json();

        if (data.success) {
            form.reset();
            Array.from(form.querySelectorAll('.is-valid')).forEach(field => field.classList.remove('is-valid'));
            submitButton.disabled = true;
            showSuccessMessage();
        } else {
            alert(`Error: ${data.data.message}`);
        }
    } catch (error) {
        console.error(`Error: ${error}`);
        alert(`Error: ${error.message || error}`);
    } finally {
        toggleLoading(loader, false);
        submitButton.disabled = false;
    }
};

document.addEventListener('DOMContentLoaded', () => {
    const contactForm = document.getElementById('contactForm');

    if (!contactForm) return;
    const loader = document.getElementById("loaderContainer");

    contactForm.addEventListener('submit', (event) => {
        event.preventDefault();
        submitForm(contactForm, contactForm.querySelector('button[type="submit"]'), loader);
    });
});
